/* tslint:disable */
/* eslint-disable */
/* @relayHash c5442d70ca25b1d3fdab8bc36ead7aa5 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ViewWorksheetPage_worksheetQueryVariables = {
    identifier: string;
};
export type ViewWorksheetPage_worksheetQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"NavHeader_viewer" | "WorksheetAuth_viewer" | "WorksheetViewer_viewer">;
    } | null;
    readonly worksheetByIdentifier: {
        readonly isVisibleToViewer: boolean;
        readonly " $fragmentRefs": FragmentRefs<"WorksheetViewer_worksheet" | "WorksheetAuth_worksheet">;
    } | null;
};
export type ViewWorksheetPage_worksheetQuery = {
    readonly response: ViewWorksheetPage_worksheetQueryResponse;
    readonly variables: ViewWorksheetPage_worksheetQueryVariables;
};



/*
query ViewWorksheetPage_worksheetQuery(
  $identifier: String!
) {
  viewer {
    ...NavHeader_viewer
    ...WorksheetAuth_viewer
    ...WorksheetViewer_viewer
  }
  worksheetByIdentifier(identifier: $identifier) {
    ...WorksheetViewer_worksheet
    ...WorksheetAuth_worksheet
    isVisibleToViewer
    id
  }
}

fragment ExerciseSummary_exercise on Exercise {
  id
  worksheet {
    id
  }
  __typename
  ... on TranslationExercise {
    ...TranslationExerciseSummary_exercise
  }
  ... on WordOrderExercise {
    ...WordOrderExerciseSummary_exercise
  }
  ... on VocabExercise {
    ...VocabExerciseSummary_exercise
  }
  ... on MultipleChoiceExercise {
    ...MultipleChoiceExerciseSummary_exercise
  }
}

fragment FeedbackModal_viewer on Viewer {
  user {
    id
  }
}

fragment MultipleChoiceExerciseAnalysis_exercise on MultipleChoiceExercise {
  content {
    prompt
    choices {
      isCorrect
      text
    }
  }
}

fragment MultipleChoiceExerciseSummary_exercise on MultipleChoiceExercise {
  content {
    prompt
    choices {
      text
      isCorrect
    }
  }
}

fragment NavHeader_viewer on Viewer {
  ...FeedbackModal_viewer
  user {
    id
    username
    isAdmin
    createdAt
    isUpgradedTeacher
    accountType
    classroomMemberships {
      level
      classroom {
        id
        title
        identifier
      }
      id
    }
    worksheets(first: 1) {
      edges {
        node {
          id
        }
      }
    }
  }
}

fragment TranslationExerciseAnalysis_exercise on TranslationExercise {
  content {
    prompt
    correctAnswers
    scrambledParts
  }
}

fragment TranslationExerciseSummary_exercise on TranslationExercise {
  content {
    prompt
    correctAnswers
    scrambledParts
  }
}

fragment VocabExerciseAnalysis_exercise on VocabExercise {
  content {
    terms {
      word
      definition
      image {
        id
        url(size: SMALL_SQUARE)
      }
    }
  }
}

fragment VocabExerciseSummary_exercise on VocabExercise {
  content {
    terms {
      word
      definition
      image {
        id
        url(size: SMALL_SQUARE)
      }
    }
  }
}

fragment WordOrderExerciseAnalysis_exercise on WordOrderExercise {
  content {
    correctAnswers
    scrambledParts
  }
}

fragment WordOrderExerciseSummary_exercise on WordOrderExercise {
  content {
    correctAnswers
    scrambledParts
  }
}

fragment WorksheetAnalysisTab_worksheet on Worksheet {
  id
  exercises {
    id
    __typename
    ... on TranslationExercise {
      ...TranslationExerciseAnalysis_exercise
    }
    ... on WordOrderExercise {
      ...WordOrderExerciseAnalysis_exercise
    }
    ... on VocabExercise {
      ...VocabExerciseAnalysis_exercise
    }
    ... on MultipleChoiceExercise {
      ...MultipleChoiceExerciseAnalysis_exercise
    }
  }
}

fragment WorksheetAuth_viewer on Viewer {
  user {
    id
  }
}

fragment WorksheetAuth_worksheet on Worksheet {
  id
  title
  visibility
  isVisibleToViewer
}

fragment WorksheetResultsTab_worksheet on Worksheet {
  id
}

fragment WorksheetStudiersTab_worksheet on Worksheet {
  id
}

fragment WorksheetViewer_viewer on Viewer {
  user {
    isUpgradedTeacher
    accountType
    id
  }
}

fragment WorksheetViewer_worksheet on Worksheet {
  ...WorksheetAnalysisTab_worksheet
  ...WorksheetResultsTab_worksheet
  ...WorksheetStudiersTab_worksheet
  id
  title
  description
  identifier
  password
  isPublished
  isVisibleToViewer
  isEditableByViewer
  visibility
  creator {
    id
  }
  exercises {
    __typename
    id
    ...ExerciseSummary_exercise
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "identifier",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "identifier",
    "variableName": "identifier"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isVisibleToViewer",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "identifier",
  "args": null,
  "storageKey": null
},
v6 = [
  (v3/*: any*/)
],
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "prompt",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "correctAnswers",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "scrambledParts",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ViewWorksheetPage_worksheetQuery",
    "type": "Root",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "NavHeader_viewer",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "WorksheetAuth_viewer",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "WorksheetViewer_viewer",
            "args": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "worksheetByIdentifier",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "Worksheet",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "FragmentSpread",
            "name": "WorksheetViewer_worksheet",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "WorksheetAuth_worksheet",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ViewWorksheetPage_worksheetQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "username",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "isAdmin",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "createdAt",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "isUpgradedTeacher",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "accountType",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "classroomMemberships",
                "storageKey": null,
                "args": null,
                "concreteType": "ClassroomMembership",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "level",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "classroom",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Classroom",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/)
                    ]
                  },
                  (v3/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "worksheets",
                "storageKey": "worksheets(first:1)",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                  }
                ],
                "concreteType": "WorksheetConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "WorksheetEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Worksheet",
                        "plural": false,
                        "selections": (v6/*: any*/)
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "worksheetByIdentifier",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "Worksheet",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "exercises",
            "storageKey": null,
            "args": null,
            "concreteType": null,
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "__typename",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "worksheet",
                "storageKey": null,
                "args": null,
                "concreteType": "Worksheet",
                "plural": false,
                "selections": (v6/*: any*/)
              },
              {
                "kind": "InlineFragment",
                "type": "TranslationExercise",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "content",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TranslationExerciseContent",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "InlineFragment",
                "type": "WordOrderExercise",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "content",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "WordOrderExerciseContent",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v9/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "InlineFragment",
                "type": "VocabExercise",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "content",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "VocabExerciseContent",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "terms",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "VocabExerciseTerm",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "word",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "definition",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "image",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Image",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "url",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "size",
                                    "value": "SMALL_SQUARE"
                                  }
                                ],
                                "storageKey": "url(size:\"SMALL_SQUARE\")"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "InlineFragment",
                "type": "MultipleChoiceExercise",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "content",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "MultipleChoiceExerciseContent",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "choices",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "MultipleChoiceExerciseChoice",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isCorrect",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "text",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          (v4/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "description",
            "args": null,
            "storageKey": null
          },
          (v5/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "password",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "isPublished",
            "args": null,
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "isEditableByViewer",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "visibility",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "creator",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": (v6/*: any*/)
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "ViewWorksheetPage_worksheetQuery",
    "id": null,
    "text": "query ViewWorksheetPage_worksheetQuery(\n  $identifier: String!\n) {\n  viewer {\n    ...NavHeader_viewer\n    ...WorksheetAuth_viewer\n    ...WorksheetViewer_viewer\n  }\n  worksheetByIdentifier(identifier: $identifier) {\n    ...WorksheetViewer_worksheet\n    ...WorksheetAuth_worksheet\n    isVisibleToViewer\n    id\n  }\n}\n\nfragment ExerciseSummary_exercise on Exercise {\n  id\n  worksheet {\n    id\n  }\n  __typename\n  ... on TranslationExercise {\n    ...TranslationExerciseSummary_exercise\n  }\n  ... on WordOrderExercise {\n    ...WordOrderExerciseSummary_exercise\n  }\n  ... on VocabExercise {\n    ...VocabExerciseSummary_exercise\n  }\n  ... on MultipleChoiceExercise {\n    ...MultipleChoiceExerciseSummary_exercise\n  }\n}\n\nfragment FeedbackModal_viewer on Viewer {\n  user {\n    id\n  }\n}\n\nfragment MultipleChoiceExerciseAnalysis_exercise on MultipleChoiceExercise {\n  content {\n    prompt\n    choices {\n      isCorrect\n      text\n    }\n  }\n}\n\nfragment MultipleChoiceExerciseSummary_exercise on MultipleChoiceExercise {\n  content {\n    prompt\n    choices {\n      text\n      isCorrect\n    }\n  }\n}\n\nfragment NavHeader_viewer on Viewer {\n  ...FeedbackModal_viewer\n  user {\n    id\n    username\n    isAdmin\n    createdAt\n    isUpgradedTeacher\n    accountType\n    classroomMemberships {\n      level\n      classroom {\n        id\n        title\n        identifier\n      }\n      id\n    }\n    worksheets(first: 1) {\n      edges {\n        node {\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment TranslationExerciseAnalysis_exercise on TranslationExercise {\n  content {\n    prompt\n    correctAnswers\n    scrambledParts\n  }\n}\n\nfragment TranslationExerciseSummary_exercise on TranslationExercise {\n  content {\n    prompt\n    correctAnswers\n    scrambledParts\n  }\n}\n\nfragment VocabExerciseAnalysis_exercise on VocabExercise {\n  content {\n    terms {\n      word\n      definition\n      image {\n        id\n        url(size: SMALL_SQUARE)\n      }\n    }\n  }\n}\n\nfragment VocabExerciseSummary_exercise on VocabExercise {\n  content {\n    terms {\n      word\n      definition\n      image {\n        id\n        url(size: SMALL_SQUARE)\n      }\n    }\n  }\n}\n\nfragment WordOrderExerciseAnalysis_exercise on WordOrderExercise {\n  content {\n    correctAnswers\n    scrambledParts\n  }\n}\n\nfragment WordOrderExerciseSummary_exercise on WordOrderExercise {\n  content {\n    correctAnswers\n    scrambledParts\n  }\n}\n\nfragment WorksheetAnalysisTab_worksheet on Worksheet {\n  id\n  exercises {\n    id\n    __typename\n    ... on TranslationExercise {\n      ...TranslationExerciseAnalysis_exercise\n    }\n    ... on WordOrderExercise {\n      ...WordOrderExerciseAnalysis_exercise\n    }\n    ... on VocabExercise {\n      ...VocabExerciseAnalysis_exercise\n    }\n    ... on MultipleChoiceExercise {\n      ...MultipleChoiceExerciseAnalysis_exercise\n    }\n  }\n}\n\nfragment WorksheetAuth_viewer on Viewer {\n  user {\n    id\n  }\n}\n\nfragment WorksheetAuth_worksheet on Worksheet {\n  id\n  title\n  visibility\n  isVisibleToViewer\n}\n\nfragment WorksheetResultsTab_worksheet on Worksheet {\n  id\n}\n\nfragment WorksheetStudiersTab_worksheet on Worksheet {\n  id\n}\n\nfragment WorksheetViewer_viewer on Viewer {\n  user {\n    isUpgradedTeacher\n    accountType\n    id\n  }\n}\n\nfragment WorksheetViewer_worksheet on Worksheet {\n  ...WorksheetAnalysisTab_worksheet\n  ...WorksheetResultsTab_worksheet\n  ...WorksheetStudiersTab_worksheet\n  id\n  title\n  description\n  identifier\n  password\n  isPublished\n  isVisibleToViewer\n  isEditableByViewer\n  visibility\n  creator {\n    id\n  }\n  exercises {\n    __typename\n    id\n    ...ExerciseSummary_exercise\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '6422b8d716010cfd8333c2e6fe073c45';
export default node;
